import { useEffect, useMemo } from "react";
import { io, type Socket } from "socket.io-client";
import { getCurrentUser } from "@/services/auth";

const VITE_SOCKET_SERVER_URL = import.meta.env.VITE_SOCKET_SERVER_URL;

export const useSocketIoClient = (): { socket: Socket } => {
  const socket = useMemo(
    () =>
      io(VITE_SOCKET_SERVER_URL, {
        autoConnect: false,
        withCredentials: true,
      }),
    []
  );

  useEffect(() => {
    let mounted = true;

    void (async (): Promise<void> => {
      const user = await getCurrentUser();
      if (user && mounted) {
        const token = await user.getIdToken();
        socket.auth = { token };
        socket.connect();
      }
    })();

    return (): void => {
      mounted = false;
      socket.disconnect();
    };
  }, [socket]);

  return { socket };
};
